<template>
  <div>
    <vue-headful title="Credimóvil | Inicio"/>
    <menu-component></menu-component>

    <!-- Slider Area -->
    <section class="main_slider_area">
        <div id="main_slider" class="rev_slider" data-version="5.1.1RC">
            <ul>
                <!-- SLIDE 1 -->
                <li data-index="rs-2" data-transition="slideoverup" data-slotamount="7" data-easein="default" data-easeout="default" data-masterspeed="1000" data-thumb="images/slider-2.jpg" data-title="Event Video">
                    <!-- MAIN IMAGE -->
                    <img src="images/slider-2.jpg" alt="Slider" data-lazyload="images/slider-2.jpg" data-bgposition="left center" data-kenburns="on" data-duration="30000" data-scalestart="110" data-scaleend="100" class="rev-slidebg" data-no-retina>

                    <!-- LAYER NR. 1 -->
                    <div class="tp-caption concept_title" id="slide-2-layer-2" data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" data-y="['top','top','top','top','top']" data-voffset="['390','390','300','180']" data-fontsize="['60','60','50','35','25']"
                        data-lineheight="['64','64','64','50']" data-width="['none','none','none','440','320']" data-height="none" data-whitespace="['nowrap','nowrap','nowrap','normal']" data-transform_idle="o:1;" data-transform_in="y:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1500;e:Power3.easeOut;"
                        data-transform_out="opacity:0;s:1000;s:1000;" data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-start="1000" data-splitin="none" data-splitout="none" data-responsive_offset="on" style="z-index: 7; white-space: nowrap; text-align:left;">Te ayudamos a
                    </div>
                    <!-- LAYER NR. 3 -->
                    <div class="tp-caption concept_title" id="slide-2-layer-3" data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" data-y="['top','top','top','top']" data-voffset="['455','455','360','220']" data-fontsize="['60','60','50','35','25']"
                        data-lineheight="['64','64','64','50']" data-width="['none','none','none','380','270']" data-height="none" data-whitespace="['nowrap','nowrap','nowrap','normal']" data-transform_idle="o:1;" data-transform_in="y:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1500;e:Power3.easeOut;"
                        data-transform_out="opacity:0;s:1000;s:1000;" data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-start="1300" data-splitin="none" data-splitout="none" data-responsive_offset="on" style="z-index: 7; white-space: nowrap; text-align:left;">cumplir tu <span>sueño</span>
                    </div>
                    <!-- LAYER NR. 4 -->
                    <div class="tp-caption paragraph_interest text-center" id="slide-2-layer-4" data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" data-y="['top','top','top','top']" data-voffset="['565','565','450','280']" data-fontsize="['27','27','25','20','20']"
                        data-lineheight="['30','30','25','20']" data-width="['380','380','320','300','300']" data-height="none" data-whitespace="normal" data-transform_idle="o:1;" data-transform_in="y:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1500;e:Power3.easeOut;"
                        data-transform_out="opacity:0;s:1000;s:1000;" data-mask_in="x:0px;y:0px;s:inherit;e:inherit;" data-start="1500" data-splitin="none" data-splitout="none" data-responsive_offset="on" style="z-index: 8; min-width: 680px; max-width: 680px; white-space: normal;">
                    </div>

                    <!-- LAYER NR. 5 -->
                    <div class="tp-caption get_started_btn" id="slide-2-layer-5" data-x="['center','center','center','center']" data-hoffset="['-110','-110','-110','-110']" data-y="['bottom','bottom','bottom','bottom']" data-voffset="['160','160','100','70']" data-width="none"
                        data-height="none" data-whitespace="nowrap" data-transform_idle="o:1;" data-transform_in="y:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1500;e:Power3.easeOut;" data-transform_out="opacity:0;s:1000;s:1000;" data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                        data-start="1700" data-splitin="none" data-splitout="none" data-responsive_offset="on" style="z-index: 6; white-space: nowrap;">
                        <a href="/pre-approval" class="theme_btn">Solicitar crédito</a>
                    </div>

                    <!-- LAYER NR. 6 -->
                    <div class="tp-caption get_started_btn" id="slide-2-layer-6" data-x="['center','center','center','center']" data-hoffset="['110','110','110','110']" data-y="['bottom','bottom','bottom','bottom']" data-voffset="['160','160','100','70']" data-width="none"
                        data-height="none" data-whitespace="nowrap" data-transform_idle="o:1;" data-transform_in="y:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;s:1500;e:Power3.easeOut;" data-transform_out="opacity:0;s:1000;s:1000;" data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                        data-start="1700" data-splitin="none" data-splitout="none" data-responsive_offset="on" style="z-index: 6; white-space: nowrap;">
                        <a href="/business-partners" class="theme_btn apply_btn">Socio comercial</a>
                    </div>
                </li>
            </ul>
            <div class="tp-bannertimer tp-bottom"></div>
        </div>
    </section>
    <!-- End Slider Area -->

    <!-- Achieve your financial -->
    <section class="achieve_financial_area afa_2">
        <div class="container">
            <div class="row achieve_inner">
                <div class="col-12 personal_tittle">
                    <p><span>Contamos con distintos planes de crédito</span><br> de acuerdo a tus posibilidades. Sin comprobar ingresos y vehículos de hasta 12 años de antigüedad</p>
                    <a href="/credit-request" class="theme_btn">Conoce más</a>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeIn d-flex">
                    <div class="achieve">
                        <div class="icon_img"><img src="images/icons/banker.png" alt="Pide crédito"></div>
                        <a href="/pre-approval">Solicita tu crédito</a>
                        <p>Credimóvil te apoya a obtener el crédito para tu automóvil de forma rápida, segura y sencilla en línea, sin buro de crédito y flexible con el mismo.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeIn d-flex" data-wow-delay="0.3s">
                    <div class="achieve">
                        <div class="icon_img"><img src="images/icons/money-bag.png" alt="Ofrece crédito"></div>
                        <a href="/business-partners">Socios comerciales</a>
                        <p>Credimóvil ayuda a aumentar las ventas de los profesionales de la venta de autos usados por medio de financiamiento de créditos.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 wow fadeIn" data-wow-delay="0.6s">
                    <div class="achieve">
                        <div class="icon_img"><img src="images/icons/money-bag-2.png" alt="Seguros"></div>
                        <a href="/quote-insurance">Seguros</a>
                        <p>Contrata en línea el mejor seguro para tu auto, contamos con las mejores compañías de seguros para ofrecerte el mejor precio del mercado, así como la atención 24/7 desde la contratación hasta el uso de tu seguro.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Achieve your financial -->

    <!-- Previous Record -->
    <section class="previous_record_area pra_2">
        <div class="previous_right">
            <div class="previous_content">
                <div class="alons_text">
                    <h2>¿Por qué Credimóvil?</h2>
                    <h4>Somos una empresa dedicada al financiamiento automotriz con más de 25 años de experiencia que nos respaldan.</h4>
                    <p>Ofrecemos servicios y soluciones financieras para fortalecer el crecimiento del patrimonio familiar de nuestros clientes, colaboradores y accionistas.</p>
                    <!-- <a href="#" class="theme_btn">Más detalles</a> -->
                </div>
                <div class="projects_done row">
                    <div class="col-md-4 counter_items">
                        <h4>Clientes</h4>
                        <h2 class="counter">10,567</h2>
                    </div>
                    <div class="col-md-4 counter_items">
                        <h4>Colaboradores</h4>
                        <h2 class="counter">345</h2>
                    </div>
                    <div class="col-md-4 counter_items">
                        <h4>Convenios</h4>
                        <h2 class="counter">56</h2>
                    </div>
                </div>
            </div>

            <div class="previous_img_2" style="position: relative">
                <iframe id="videoLanding" src="https://www.youtube.com/embed/L_MciDm4NFc?autoplay=1;showinfo=0;playlist=L_MciDm4NFc;loop=1;mute=1" style="position: absolute; left: 15%; top: 11%; width: 70%; height: 73%;"></iframe>
                <img src="images/video-mk.png">
            </div>
        </div>
    </section>
    <!-- Previous Record -->

    <!-- Application Process-->
    <div class="application_process">
        <div class="container">
            <div class="tittle la">
                <h2>Conoce los pasos para <span>solicitar un crédito</span></h2>
            </div>
            <div class="row">
                <!-- Step -->
                <div class="col-lg-4 col-md-6 wow fadeIn">
                    <div class="step_item">
                        <h3>Paso 1</h3>
                        <img src="images/icons/step-1.png" alt="Paso 1">
                        <p>Llena tu solicitud, tomará unos cuantos minutos</p>
                        <a href="/pre-approval" class="theme_btn">Aplicar ahora</a>
                    </div>
                </div>
                <!-- Step -->
                <div class="col-lg-4 col-md-6 wow fadeIn" data-wow-delay="0.3s">
                    <div class="step_item">
                        <h3>Paso 2</h3>
                        <img src="images/icons/step-2.png" alt="Paso 2">
                        <p>Pre aprobamos tu crédito inmediatamente<br> <br></p>
                    </div>
                </div>
                <!-- Step -->
                <div class="col-lg-4 col-md-6 wow fadeIn" data-wow-delay="0.6s">
                    <div class="step_item">
                        <h3>Paso 3</h3>
                        <img src="images/icons/step-3.png" alt="Paso 3">
                        <p>Nos comunicamos contigo para aprobar tu crédito en menos de 48 horas</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Application Process-->

    <!-- Getting a Loan -->
    <section class="getting_loan_area gla_2">
        <div class="container">
            <div class="row getting_inner">
                <div class="col-lg-6 loan-card">
                    <img src="images/loan-card.png" alt="Ofrecer crédito">
                </div>
                <div class="col-lg-6 getting_first">
                    <div class="tittle la">
                        <h2>¿Quieres ofrecer <span>un crédito?</span></h2>
                    </div>
                    <div class="getting_items gi_f wow fadeInUp">
                        <span><img src="images/icons/solicitud.png" alt="Solicitud"></span>
                        <h3>Solicitud</h3>
                        <p>Llena tu solicitud en cuestión de minutos</p>
                    </div>
                    <div class="getting_items wow fadeInUp" data-wow-delay="0.3s">
                        <span><img src="images/icons/pre-aprobacion.png" alt="Pre-aprobación"></span>
                        <h3>Pre aprobación</h3>
                        <p>Un asesor de credimóvil se comunicará contigo para tu pre aprobación</p>
                    </div>
                    <div class="getting_items wow fadeInUp" data-wow-delay="0.6s">
                        <span><img src="images/icons/beneficios.png" alt="Beneficios"></span>
                        <h3>Beneficios</h3>
                        <p>Utiliza los grandes beneficios de credimóvil</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Getting a Loan -->

    <!-- Potential Area -->
    <section class="potential_area poa_2">
        <div class="container">
            <div class="tittle">
                <a href="/business-partners">
                    <h2>¿Estás interesado en <span>nuestros servicios?</span> </h2>
                    <p>Conoce los grandes beneficios para tu negocio</p>
                </a>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-6 wow fadeIn" data-wow-delay="0.9s">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/nuevos-clientes.png" alt="Nuevos clientes">
                            </div>
                            <a class="heding">Llega a más personas</a>
                            <h6>y gana nuevos clientes</h6>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6  wow fadeIn" data-wow-delay="0.6s">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/aumenta-ingresos.png" alt="Aumenta ingresos">
                            </div>
                            <a class="heding">Aumenta tus ingresos</a>
                            <h6>de manera exponencial</h6>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6  wow fadeIn" data-wow-delay="0.3s">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/agiliza.png" alt="Agiliza tu procedimiento">
                            </div>
                            <a class="heding">Agiliza tu procedimiento</a>
                            <h6>para la venta de automóviles</h6>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6  wow fadeIn">
                    <div class="potential">
                        <div class="ptl_containt">
                            <div class="loan_img">
                                <img src="images/icons/ahorra-tiempo.png" alt="Ahorra tiempo">
                            </div>
                            <a class="heding">Ahorra<br> tiempo</a>
                            <h6>en cerrar ventas</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Potential Area -->

    <!-- Get started -->
    <section class="get_started_area">
        <div class="container">
            <h2>¿Preparado para comenzar?</h2>
            <p>Inicia tu trámite a través de nuestra plataforma</p>
            <a href="/pre-approval" class="theme_btn">Aplicar ahora</a>
        </div>
    </section>
    <!-- End get started -->

    <!-- Map and From Area -->
    <section class="inicio-contacto map_from_area">
        <div class="map_area">
            <div class="map_content">
                <iframe src="https://www.google.com/maps/d/u/0/embed?mid=15t3qJqAwN9WTPYplZFk1lDq5Y4N_FqVK"
                    height="671" frameborder="0" style="border:0; width: 100%" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div>
        <div class="contact_inner contact-form-title">
            <form class="from_main" novalidate="novalidate">
                <h2>¿Tienes alguna pregunta que hacer? <br><span>por favor, escríbenos</span> </h2>
                <div class="form-group">
                    <input type="text" class="form-control" id="name" name="name" placeholder="Nombre" v-model="contactForm.name" :class="{ 'error': $v.contactForm.name.$invalid }">
                </div>
                <div class="form-group">
                    <input type="email" class="form-control" id="email" name="email" placeholder="Correo electrónico" v-model="contactForm.email" :class="{ 'error': $v.contactForm.email.$invalid }">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" id="subject" name="subject" placeholder="Asunto" v-model="contactForm.subject" :class="{ 'error': $v.contactForm.subject.$invalid }">
                </div>
                <div class="form-group">
                    <textarea class="form-control" id="message" name="message" placeholder="Mensaje" v-model="contactForm.text" :class="{ 'error': $v.contactForm.text.$invalid }"></textarea>
                </div>
                <div class="form-group">
                    <button class="theme_btn btn" id="js-contact-btn" type="button" v-on:click="sendContact()" :disabled="$v.contactForm.$invalid">Enviar</button>
                    <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div>
                </div>
            </form>
        </div>
    </section>
    <!-- End Map and From Area -->
  </div>
</template>

<script>
  import { required, minLength, between } from 'vuelidate/lib/validators';

  export default {
    name: 'Home',
    data() {
      return {
        contactForm: {
          name: '',
          email: '',
          subject: '',
          text: '',
        }
      }
    },
    validations() {
      return {
        contactForm: {
          name: { required },
          email: { required },
          subject: { required },
          text: { required }
        }
      }
    },
    methods: {
        sendContact() {
            var data = {
                data: {
                    name: this.contactForm.name,
                    email: this.contactForm.email,
                    subject: this.contactForm.subject,
                    message: this.contactForm.text,
                }
            };
            this.$InsuranceService.sendContact(data).then((result) => {
                alert('Exito, su petición ha sido enviada con exito');
                this.contactForm.name = '';
                this.contactForm.email = '';
                this.contactForm.subject = '';
                this.contactForm.text = '';
                window.scrollTo(0, 0);
            }, (err) => {
                alert(err.msg);
            });
        }
    },
  }
</script>

<style lang="scss">
  .error {
    border-color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue